import { DialogActions, DialogContent, Grid } from '@mui/material'
import { ReactNode } from 'react'
import PaymentAppbar from './PaymentAppbar'
import SplitPaymentButton from './SplitPaymentButton'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'

interface IPaymentDialogMobileContent {
    topSection: ReactNode
    bottomSection?: ReactNode
    finishButton: ReactNode
    onBack?: () => void
    hidePaymentSelect?: boolean
    onViewInfo?: () => void
}

function PaymentDialogMobileContent({
    topSection,
    bottomSection,
    finishButton,
    onBack,
    onViewInfo,
}: IPaymentDialogMobileContent) {
    const { isSplitPayment } = usePaymentContext()
    return (
        <>
            <PaymentAppbar
                onViewInfo={onViewInfo}
                hidePaymentSelect={isSplitPayment}
                onBack={onBack}
            />
            <DialogContent sx={{ p: 1 }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="space-between"
                    minHeight="100%"
                >
                    <Grid item>
                        <Grid container spacing={1} direction={'column'}>
                            <Grid item>{topSection}</Grid>
                            {!isSplitPayment && (
                                <Grid item>
                                    <SplitPaymentButton />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    {bottomSection && <Grid item>{bottomSection}</Grid>}
                </Grid>
            </DialogContent>
            <DialogActions>{finishButton}</DialogActions>
        </>
    )
}
export default PaymentDialogMobileContent
